let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7PWDn")).then(() => parcelRequire('9OpH3'));